// Writes your routes here

// manpower-management
export const accommodationListApi = 'accommodationManagement/manpower-management/list'
export const accommodationStoreApi = 'accommodationManagement/manpower-management/store'
export const accommodationUpdateApi = 'accommodationManagement/manpower-management/update'
export const accommodationToggleStatusApi = 'accommodationManagement/manpower-management/toggle-status'

// procurement-management
export const procurementListApi = 'accommodationManagement/procurement-management/list'
export const procurementStoreApi = 'accommodationManagement/procurement-management/store'
export const procurementUpdateApi = 'accommodationManagement/procurement-management/update'
export const procurementToggleStatusApi = 'accommodationManagement/procurement-management/toggle-status'

// accommodation-info
export const accommodationInfoListApi = 'accommodationManagement/accommodation-info/list'
export const accommodationInfoStoreApi = 'accommodationManagement/accommodation-info/store'
export const foodPackageListApi = 'accommodationManagement/accommodation-info/package-list'
export const accommodationInfoUpdateApi = 'accommodationManagement/accommodation-info/update'
export const accommodationInfoToggleStatusApi = 'accommodationManagement/accommodation-info/toggle-status'
export const getTrainerTrainee = 'accommodationManagement/accommodation-info/get-trainer-trainee'
